import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor() { }

  // public filesurl = 'http://localhost:8088/'; //sri
  public filesurl= '//theapi.backseat-trader.com/'

  //public url = this.filesurl + 'v1/'
  public url = this.filesurl
}
